export var RULE_MODES;
(function (RULE_MODES) {
    RULE_MODES[RULE_MODES["slider"] = 0] = "slider";
    RULE_MODES[RULE_MODES["text"] = 1] = "text";
    RULE_MODES[RULE_MODES["color"] = 2] = "color";
})(RULE_MODES || (RULE_MODES = {}));
